var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"jam jam-flickr",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -7 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('circle',{attrs:{"cx":"4.727","cy":"4.757","r":"4.727"}}),_c('circle',{attrs:{"cx":"15.255","cy":"4.757","r":"4.727"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }